import Modernizr from 'modernizr'; window.Modernizr = Modernizr;

OAX.preloader_bar.go( 20 );

require( 'lazysizes/plugins/include/ls.include.js' );
require( 'lazysizes/plugins/unveilhooks/ls.unveilhooks.js' );
require( 'lazysizes' );

OAX.preloader_bar.go( 30 );

require( '../lib/gsap/uncompressed/TweenMax.js' );
require( '../lib/gsap/uncompressed/plugins/ScrollToPlugin.js' );

OAX.preloader_bar.go( 40 );

require( 'slick-carousel/slick/slick.js' );

OAX.preloader_bar.go( 50 );

/*
 * require( '../lib/gsap/uncompressed/plugins/CSSPlugin.js' );
 * 
 * require( '../lib/gsap/uncompressed/plugins/MorphSVGPlugin.js' );
 * require( '../lib/gsap/uncompressed/easing/CustomEase.js' );
 * require( '../lib/gsap/uncompressed/plugins/DrawSVGPlugin.js' );
 */

import ScrollMagic from 'scrollmagic'; window.ScrollMagic = ScrollMagic;
require( 'animation.gsap' );
require( 'debug.addIndicators' );

/*
 * require( '../lib/gsap/uncompressed/plugins/Physics2DPlugin.js' );
 * require( '../lib/gsap/uncompressed/plugins/ModifiersPlugin.js' );
 * require( '../lib/lightgallery/dist/js/lightgallery.js' );
 */



// WEBPACK FOOTER //
// ./js/autoload/vendor.js